export default defineAppConfig({
  copy: {
    establishYear: 2025,
    runByName: 'C&R Legal Agency Co., Ltd.',
  },
});
